import React from 'react';
import PropTypes from 'prop-types';

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            current: props.current || 0,
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.current !== this.state.current) {
            this.setState({ current: nextProps.current });
        }
    }

    onSubmit(e) {
        e.preventDefault();
        document.querySelector(':focus').blur();

        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    }

    render() {
        const params = {};

        if (this.props.action) {
            params.action = this.props.action;
        }

        if (this.props.method) {
            params.action = this.props.method;
        }

        if (this.props.onClick) {
            params.onClick = this.props.onClick;
        }

        return (
            <form {...params} data-current={this.state.current} onSubmit={this.onSubmit} noValidate>
                {this.props.children}
            </form>
        );
    }
}

Form.propTypes = {
    children: PropTypes.node,
    action: PropTypes.string,
    method: PropTypes.string,
    onSubmit: PropTypes.func,
    current: PropTypes.number,
};

export default Form;
